// require('./styles/theme-custom.scss');
require('./styles/themes/theme.scss');

require('./styles/styles.scss');
// require('./styles.css');

// [TBD] remove at some point
// require('bootstrap-css-only/css/bootstrap.min.css');